import { AxiosMethods } from '@setvi/shared/enums';
import type { ProductAssetsResponse } from '@setvi/shared/interfaces';
import { axiosHelper } from '@setvi/shared/services';
import type { AxiosError } from 'axios';

export enum ProductsQueryKey {
  PRODUCT_ASSETS = 'product_assets'
}

enum ProductsApi {
  Assets = '/product/assets'
}

const EMPTY_ASSETS: ProductAssetsResponse = {
  productId: '',
  sku: '',
  images: [],
  documents: []
};

/**
 * A product's pictures and documents from revops-api. `productId` is the
 * product id or its SKU, sent as a query parameter because a SKU may contain
 * `/`. An unknown product answers 404; that is "no resources", not an error,
 * so it resolves to an empty result instead of surfacing a toast.
 */
export const getProductAssetsQuery = (productId: string) => ({
  queryKey: [ProductsQueryKey.PRODUCT_ASSETS, productId],
  queryFn: async (): Promise<ProductAssetsResponse> => {
    try {
      const data: ProductAssetsResponse = await axiosHelper({
        endpoint: ProductsApi.Assets,
        method: AxiosMethods.GET,
        params: { productId },
        baseURL: process.env.REVOPS_API
      });
      return {
        ...EMPTY_ASSETS,
        ...data,
        images: data?.images ?? [],
        documents: data?.documents ?? []
      };
    } catch (error) {
      if ((error as AxiosError)?.response?.status === 404) return EMPTY_ASSETS;
      throw error;
    }
  },
  enabled: !!productId
});
